<template>
  <app-page-container :min-height="200">
    <app-flex-grid :rows="[['250px', '300px']]">
      <template #col-1-1>
        <app-input
          @input.native="onReservationSearch"
          v-model="search"
          type="search"
          placeholder="Search by client, lead number"
          name="search"
        />
      </template>
      <template #col-1-2>
        <app-select
          @input="onChangeFilter"
          v-model="filter_hotel"
          :reduce="item => item.id"
          :options="filter_hotel_options"
          placeholder="Hotel"
        />
      </template>
    </app-flex-grid>
    <app-spinner v-if="!is_page_loaded"/>
    <template v-else>
      <template v-if="already_booked.length > 0">
        <app-cells>
          <h2 class="title">Already booked. Just confirm and fill the info</h2>
        </app-cells>
        <app-cells-grid :columns="1" gap="10px" :margin-bottom="30">
          <AppAccMeal
            v-for="(meal, index) in already_booked"
            :key="`already_booked_${meal.id}`"
            :reservation="meal"
            :order-number="index + 1"
          />
        </app-cells-grid>
      </template>
      <template v-if="meals_waiting_hotel.length > 0">
        <h2 class="title title--mb15">Waiting hotel</h2>
        <app-cells-grid :columns="1" gap="10px" :margin-bottom="30">
          <AppAccMeal
            v-for="(meal, index) in meals_waiting_hotel"
            :key="`waiting_hotel_${meal.id}`"
            :reservation="meal"
            :order-number="index + 1"
            :countdown="meal.last_email_sent_at"
          />
        </app-cells-grid>
      </template>
      <template v-if="meals_booked.length > 0">
        <h2 class="title title--mb15">Booked</h2>
        <app-cells-grid :columns="1" gap="10px" :margin-bottom="30">
          <AppAccMeal
            v-for="(meal, index) in meals_booked"
            :key="`booked_${meal.id}`"
            :reservation="meal"
            :order-number="index + 1"
          />
        </app-cells-grid>
        <app-cells :position="pagination_booked.pages > 1 ? 'between' : 'end'">
          <paginate
            :clickHandler="onClickBookedPagination"
            v-if="pagination_booked.pages > 1"
            v-model="pagination_booked.page"
            :page-count="pagination_booked.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
          <app-table-records :all="pagination_booked.count" :count="meals_booked.length" :page="pagination_booked.page" />
        </app-cells>
      </template>
    </template>
  </app-page-container>
</template>

<script>
import { getHotelsListSearch, getReservationsMeals } from '@/http'
import AppAccMeal from '@/components/AppAccMeal.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'ReservationMealsUpcoming',
  components: { AppAccMeal },
  data() {
    return {
      is_page_loaded: false,
      meals_waiting_hotel: [],
      meals_booked: [],
      pagination_booked: {
        pages: 1,
        page: 1,
        count: 1,
      },
      search: null,
      filter_hotel: null,
      filter_hotel_options: [],
      already_booked: [],
    }
  },
  created() {
    this.fetchAllItems()
    getHotelsListSearch({ active: true }).then(res => { this.filter_hotel_options = res.data })
  },
  methods: {
    fetchAllItems() {
      Promise.all([
        getReservationsMeals({
          reservation_status: 'new',
          sales_status_exclude: 'cancel',
          ordering: 'last_email_sent_at',
          search: this.search,
          hotel_id: this.filter_hotel,
        }),
        getReservationsMeals({
          page: this.pagination_booked.page,
          page_size: 20,
          reservation_status: 'booked',
          category: 'upcoming',
          search: this.search,
          hotel_id: this.filter_hotel,
        }),
        getReservationsMeals({
          reservation_status: 'new',
          already_booked: true,
          search: this.search,
          hotel_id: this.filter_hotel,
        }),
      ])
        .then(res => {
          this.meals_waiting_hotel = res[0].data
          this.meals_booked = res[1].data.results
          this.pagination_booked.pages = res[1].data.pages
          this.pagination_booked.count = res[1].data.count
          this.already_booked = res[2].data
          this.is_page_loaded = true
        })
    },
    fetchBookedItems() {
      getReservationsMeals({
        page: this.pagination_booked.page,
        page_size: 20,
        reservation_status: 'booked',
        category: 'upcoming',
        search: this.search,
        hotel_id: this.filter_hotel,
      })
        .then(res => {
          this.meals_booked = res.data.results
          this.pagination_booked.pages = res.data.pages
          this.pagination_booked.count = res.data.count
          this.is_page_loaded = true
        })
    },
    onClickBookedPagination(page) {
      this.pagination_booked.page = page
      this.fetchBookedItems()
    },
    onReservationSearch() {
      this.searchReservation(this)
      this.is_page_loaded = false
    },
    searchReservation: debounce(vm => {
      vm.fetchAllItems()
    }, 350),
    onChangeFilter() {
      this.pagination_booked.page = 1
      this.search = ''
      this.is_page_loaded = false
      this.fetchAllItems()
    },
  }
}
</script>
